<template>
  <div class="hello">
  
    <div class="Joinbanner">
  
      <img src="../assets/Innerbanner.png" style="width:100%;height:auto;" class="JobsBanner">
  
    </div>

    <div class="Job">
  
        <div class="FirstTitle">
  
          <p>JAVA高级开发工程师<img src="../assets/ho-t.png" class="hotPic"></p>
  
            <img :src="button1" class="backPic" @mouseover="mouseOn" @mouseout="mouseOut" @click="onclick">
  
        </div>
  
        <div class="p1">
  
          <h4>职位描述</h4>
  
          <p>1、独立完成中小型项目的系统分析、设计，并主导完成详细设计和编码的任务，确保项目的进度和质量;<br> 2、参与建设通用、灵活的业务基础平台，支撑上层多场景的业务;
  
            <br> 3、执行代码检查并提供优化建议，对部分人员进行JAVA技术、开发技能等知识普及及能力培养;
  
            <br> 4、改善、维护和优化相关的产品的质量、性能、提升用户使用体验。
  
          </p>
  
        </div>
  
        <div class="p1">
  
          <h4>任职要求：</h4>
  
          <p>1、5年以上应用系统设计及开发经验；<br> 2、精通负载均衡机制、应用集群搭建、数据库集群搭建；
  
            <br> 3、精通J2EE技术平台及主流框架，具有Hibernate、Spring、Struts、mybatis等框架开发经验，深刻理解SpringMVC；
  
            <br> 4、精通Web页面开发，熟练运用HTML、JavaScript、ajax、css、JQuery;
  
            <br> 5、精通Tomcat等主流J2EE应用服务,能在Unix/Linux上布署服务;
  
            <br> 6、精通MySQL等数据库，熟悉关系数据库应用设计开发及优化;
  
            <br> 7、有基于阿里云平台的研发经验优先考虑；
  
            <br> 8、有大数据或高并发数据库开发经验优先考虑。
  
          </p>
  
        </div>
  
        <div class="p1">
  
          <h4>薪酬福利：</h4>
  
          <p>1、各类假期：带薪年假、带薪病假、婚假、产假、国家法定假期，一样都不能少；<br> 2、完善的福利：五险一金、股权激励、免费班车；
  
            <br> 3、薪酬待遇：有竞争力的薪酬福利待遇体系，丰厚的年终奖金等着你来拿；
  
            <br> 4、公司活动：不定期举办各类员工活动，月度生日会、节日活动、图书分享会，每周花样文体活动等着你来参加；
  
            <br> 5、工作环境：公司提供优美的办公环境，提供优质资源；
  
            <br> 6、吃货福利：蛋糕、甜点、水果、饮料等其他小零食。
  
          </p>
  
        </div>
  
        <div class="p1">
  
          <h4>工作地址：</h4>
  
          <p>广州 - 天河区 - 体育东路122号羊城国际商贸中心东塔3209单元&nbsp&nbsp&nbsp<span style="color: #0099cc;  font-family: FZLTXHK-GBK1-0;
  
    font-size: 16px;
  
    line-height: 1.88;
  
    letter-spacing: 0.8px;">查看地图 ></span></p>
  
        </div>
  
        <img :src="Buttonn" class="handle" @mouseover="mouseOnn" @mouseout="mouseOutt" @click="onclickk">
  
      </div>
  
  </div>
</template>

<script>
  import pic1 from "../assets/a1.png"
  
  import pic2 from "../assets/a2.png"
  
  import pic3 from "../assets/a3.png"
  
  import pic4 from "../assets/a4.png"
  
  import pic5 from "../assets/a5.png"
  
  import pic6 from "../assets/a6.png"
  
  import button1 from "../assets/back.png"
  
  import button2 from "../assets/backmouse.png"
  
  import button3 from "../assets/backclick.png"
  
  import button4 from "../assets/handle.png"
  
  import button5 from "../assets/handlemouse.png"
  
  import button6 from "../assets/handleclick.png"

  export default {
  
    name: 'hello',

    data() {
  
      return {
  
      }
  
    },
  
    methods: {
    }
  
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped media="all" type="text/css">
.hello {
    background: #f9f9f9;
}
.Job {
    width: 60vw;
    margin: 0 auto;
    margin-top: -20rem;
    background: #fff;
    position: relative;
    z-index: 9;
    padding: 5rem 15rem;
    letter-spacing: 1px;
}
.FirstTitle {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.FirstTitle p {
    display: flex;
    align-items: center;
    font-size: 18px;
}
.hotPic {
    margin: 0 10px;
}
.p1 p {
    font-size: 14px;
    line-height: 2;
    
}
</style>



// WEBPACK FOOTER //
// JobsDetails.vue?28aae7c0